import { useContext, useEffect } from "react";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";
import {
  assembleResult,
  handleOnChangeEvents,
  useSearchFilterHook
} from "./filterhelper";
import handlers from "./filterhelper/internal/handlers";

export const useSearchFilterHelper = () => {
  const { updateSearchRequest, searchRequest: filters } =
    useContext(AccountSearchContext);

  const currentStates = useSearchFilterHook();

  useEffect(
    () => {
      if (!filters) return;
      handlers.forEach(handler => handler(filters, currentStates));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filters]
  );

  const {
    accountTypesOnChange,
    CountryOnChange,
    urlOnChange,
    controlCenterPlatformnsChange,
    idOnChange,
    nameOnChange,
    verticalTypesnChange,
    postalCodeOnChange,
    StatusesOnChange,
    dateAfterOnChange,
    dateBeforeOnChange,
    StatesOnChange,
    franchisesMatchAllOnChange,
    franchisesMatchAnyOnChange,
    franchisesMatchNoneOnChange,
    dealerCodesValueMatchAllOnChange,
    dealerCodesMatchAllOnChange,
    resourcesMatchAllOnChange,
    resourcesMatchAnyOnChange,
    resourcesMatchNoneOnChange
  } = handleOnChangeEvents(currentStates, updateSearchRequest, filters);

  const returnValue = assembleResult(currentStates, {
    accountTypesOnChange,
    CountryOnChange,
    urlOnChange,
    controlCenterPlatformnsChange,
    idOnChange,
    nameOnChange,
    verticalTypesnChange,
    postalCodeOnChange,
    StatusesOnChange,
    dateAfterOnChange,
    dateBeforeOnChange,
    StatesOnChange,
    franchisesMatchAllOnChange,
    franchisesMatchAnyOnChange,
    franchisesMatchNoneOnChange,
    dealerCodesValueMatchAllOnChange,
    dealerCodesMatchAllOnChange,
    resourcesMatchAllOnChange,
    resourcesMatchAnyOnChange,
    resourcesMatchNoneOnChange
  });
  return returnValue;
};

export * from "./defaults";
